/**
* Featured Industries JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Industries component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'featured-industries',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.featured-industries__industry' ).each( function( key, industry ) {
        const splide = new Splide( $( industry ).next()[0], {
          pagination: false,
          arrows: false,
          type: 'loop',
          autoWidth: true,
          autoScroll: {
            autoStart: false,
          },
        } );

        splide.mount( {AutoScroll} );

        $( industry ).on( 'mouseenter', function() {
          splide.Components.AutoScroll.play();
        } ).on( 'mouseleave', function() {
          splide.Components.AutoScroll.pause();
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-industries', COMPONENT );
} )( app );
